/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import { BackButton } from 'components/common/BackButton/BackButton';
import PaymentForm from 'components/common/PaymentForm';

const NewPayment = ({ paymentStore }) => {
  useEffect(() => {
    return () => {
      paymentStore.resetPaymentStore();
    };
  }, []);

  return (
    <div className={'page-container'}>
      <div className={'content-wrapper'}>
        <PaymentForm />
      </div>
    </div>
  );
};

NewPayment.propTypes = {
  paymentStore: MobXPropTypes.observableObject
};

export default inject('paymentStore')(observer(NewPayment));
